import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedService } from '../services/shared.service';

@Component({
    selector: 'navigation-trigger',
    templateUrl: './navigation-trigger.component.html',
    styleUrls: ['./navigation-trigger.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NavigationTriggerComponent implements OnInit {
    sidebarVisible: boolean;

    constructor(private sharedService: SharedService) {
        sharedService.sidebarVisibilitySubject.subscribe((value) => {
            this.sidebarVisible = value;
        });
    }

    toggleSidebarVisibility() {
        this.sharedService.toggleSidebarVisibilty();
    }

    ngOnInit() {

    }
}
